import React from 'react'

const SvgNoDataFilled = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M22 12.147c-.33-.15-.712-.25-1.142-.25-.962 0-1.676.495-2.126.955l-.818.819-.827-.827h-.001c-.453-.455-1.168-.941-2.122-.941s-1.668.487-2.121.94A3.296 3.296 0 0012.078 14H2v-4h20v2.147zm-15.293.56a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414zM12.106 16c.184.452.466.815.738 1.086l.002.002.825.826-.815.815c-.464.45-.96 1.163-.96 2.126 0 .432.1.814.25 1.145H4c-1.333 0-2-.693-2-2.08V16h10.106zm-5.399 2.707a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414zM2 8h20V4c0-1.332-.67-2-2.01-2H4c-1.333 0-2 .667-2 2v4zm4.707-1.293a1 1 0 11-1.414-1.414 1 1 0 011.414 1.414z'
    />
    <path
      fillRule='evenodd'
      clipRule='evenodd'
      d='M15.671 14.257l2.243 2.242 2.242-2.242c.464-.48.935-.48 1.415 0s.48.95 0 1.414l-2.243 2.243 2.243 2.242c.471.472.471.943 0 1.415-.472.471-.943.471-1.415 0l-2.242-2.243-2.243 2.243c-.46.482-.932.482-1.414 0-.482-.483-.482-.954 0-1.415l2.242-2.242-2.242-2.243c-.472-.47-.472-.942 0-1.414s.943-.472 1.414 0z'
    />
  </svg>
)

export default SvgNoDataFilled
